'use strict';
import React, { useState, useEffect, memo } from 'react';

import { Button, Divider } from '@alifd/next';

import './App.css';
import MainView from './Main'
import TermsView from './Terms'
import PrivacyView from './Privacy'

import ApplicationConfig from './constant.jsx';

export default memo((props) => {
  const [index, handleModalIndex] = useState(0);

  return (
    <div className="flex-col mod">
      <div className="flex-row header">
        <div className="flex-row block">
          <Button
            className="logo"
            onClick={() => {
              handleModalIndex(0);
            }}
          />
          <div className="flex-row container">
            <Button
              className="headeritem"
              onClick={() => {
                handleModalIndex(1);
              }}
              ghost={'true'}
              component={'a'}
              type={'normal'}
              text={false}
              onclick={() => {
                handleModalIndex(1);
              }}
              herf={'#headeritem-tag'}
            >
              用户协议
            </Button>
            <Divider className="class-divider"></Divider>
            <Button
              className="headeritem"
              ghost={'true'}
              component={'a'}
              onclick={() => {
                handleModalIndex(2);
              }}
              onClick={() => {
                handleModalIndex(2);
              }}
              herf={'#headeritem-tag'}
            >
              隐私协议
            </Button>
          </div>
        </div>
      </div>
      {(index == 1) ? <TermsView /> : (index == 2) ? <PrivacyView /> :  <MainView />}

      <div className="footer">
        {/* <p>深圳市欢图科技有限公司 版权所有 © 秀影</p> */}
        <p>{ApplicationConfig.icpTitle}</p>
        <Divider className="class-divider" />
        <div className="justify-center class-footer-content">
          <div className="registration"></div>
          <span className="class-7">| </span>
          <Button
            className="class-9"
            size={'small'}
            type={'normal'}
            component={'a'}
            ghost={'true'}
            text={true}
            disabled={false}
          >
            <a href="https://beian.miit.gov.cn">{ApplicationConfig.icpUrl}</a>
          </Button>
          <span className="class-8"> |</span>
          <p>{ApplicationConfig.conus}</p>
        </div>
      </div>
    </div>
  );
});
